/* eslint-disable no-console */
export class PublicApi {
  #tokenCache = {}
  constructor(attributes) {
    this.attributes = attributes
  }
  getUser(force, localScopes = []) {
    const scopes = encodeURIComponent(
      [...this.attributes.scopes, ...localScopes]
        .filter((s, i, a) => a.indexOf(s) === i)
        .sort()
        .join(' ')
    )
    if (!force && this.#tokenCache[scopes] && this.#isValid(this.#tokenCache[scopes])) {
      console.log('[stratsys-public-runtime] Using access token from cache...')
      return Promise.resolve(this.#tokenCache[scopes].token)
    }

    console.log('[stratsys-public-runtime] Loading new access token from idp...')
    const request = new XMLHttpRequest()
    return new Promise((resolve, reject) => {
      request.onreadystatechange = () => {
        if (request.readyState !== 4) {
          return
        }

        if (request.status >= 200 && request.status < 300) {
          const token = JSON.parse(request.response)
          this.#tokenCache[scopes] = {
            token,
            loaded: Date.now()
          }
          resolve(token)
        } else {
          reject({
            status: request.status,
            statusText: request.statusText
          })
        }
      }

      request.open('POST', this.attributes.url, true)
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      request.send(
        `grant_type=client_credentials&scope=${scopes}&client_id=${this.attributes.clientId}`
      )
    })
  }
  #isValid(cachedToken) {
    const loaded = new Date(cachedToken.loaded)
    const offset = (cachedToken.token.expires_in || 0) - 60
    loaded.setSeconds(loaded.getSeconds() + offset)
    return loaded > new Date(Date.now())
  }
}
